(() => {
  const targetText = "都昌信息科技有限公司";

  function patchFillText(win) {
    const proto = win?.CanvasRenderingContext2D?.prototype;
    if (!proto || proto.__patched__) return;

    const original = proto.fillText;
    proto.fillText = function (text, ...args) {
      if (typeof text === "string" && text.includes(targetText)) return;
      return original.call(this, text, ...args);
    };
    proto.__patched__ = true;
    console.log("[fillText] patch applied to", win === window ? "main window" : "iframe");
  }

  function patchIframe() {
    const iframe = document.getElementById("myWriterControl_IFrame_Print");
    if (iframe?.contentWindow) {
      try {
        patchFillText(iframe.contentWindow);
      } catch (e) {
        console.warn("Failed to patch iframe:", e);
      }
    }
  }

  patchFillText(window);
  patchIframe();

  const observer = new MutationObserver(patchIframe);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("beforeprint", patchIframe);
})();
